import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import EmailProviderGuard from "../../components/EmailProviderGuard";
import RoleBasedDashboard from "../mainMenu/Dashboard";
import NewDashboard from "../mainMenu/Dashboard/dashboard";
import RevenueSummary from "../mainMenu/Dashboard/revenueSummary";
import SalesSummary from "../mainMenu/Dashboard/salesSummary";
import ContactDetails from "../crm/contacts/ContactDetails";
import BlankPage from "../pages/blankPage";
import DealsDetails from "../crm/deals/dealsDetails";
import DealsContainer from "../crm/deals/DealsContainer";
import DeleteRequest from "../userManagement/deleteRequest";
import ComingSoon from "../pages/comingSoon";
import Manageusers from "../userManagement/manageusers";
import Localization from "../settings/websiteSettings/localization";
import LeadDetails from "../crm/leads/leadDetails";
import LeadsContainer from "../crm/leads/LeadsContainer";
import Login from "../auth/login";
import Register from "../auth/register";

import AccountVerification from "../auth/accountVerification";
import EmailVerification from "../auth/emailVerification";
import EmailConnection from "../auth/emailConnection";
import Success from "../auth/success";
import ResetPassword from "../auth/resetPassword";
import ForgotPassword from "../auth/forgotPassword";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import RedirectPage from "../pages/redirectPage";
import DealsSettings from "../settings/lifecycleSettings/deals";
import LeadsSettings from "../settings/lifecycleSettings/leads";
import PipelineSettings from "../settings/lifecycleSettings/pipeline";
import ProposalsSettings from "../settings/lifecycleSettings/proposals";
import ContractsSettings from "../settings/lifecycleSettings/contracts";
import SourceSettings from "../settings/sourceSettings/sourceSettings";
import SalesActivityTypeSettings from "../settings/salesActivityType/salesActivityTypeSettings";
import LostReasons from "../settings/lifecycleStatusReason/lostReasons";
import WonReasons from "../settings/lifecycleStatusReason/wonReasons";
import Profile from "../settings/generalSettings/profile";
import ProductServices from "../settings/productServices/ProductServices";
import CustomFields from "../settings/customFields/CustomFields";
import AuditLog from "../settings/auditLogs/auditLog";
import Security from "../settings/generalSettings/security";
import EmailSettings from "../settings/integrationsettings/integrationSettings";
import ApiIntegrationSettings from "../settings/integrationsettings/apiIntegrationSettings";
import AdminApiIntegration from "../settings/apiIntegration/adminApiIntegration";
import CompanySettings from "../settings/websiteSettings/general";
import ApprovalPolicy from "../settings/websiteSettings/ApprovalPolicy";
import EmailWorkflow from "../settings/workflowConfiguration/EmailWorkflow";
import Language from "../settings/websiteSettings/language";
import UnderMaintenance from "../pages/underMaintenance";
import EmailList from "../application/components/email/emailList";
import EmailDetail from "../application/components/email/email-detail";
import Chat from "../application/components/chat/chat";
import Calendar from "../application/components/calendar/calendar";
import ExternalTask from "../application/components/external task/externalTask";
import ContactsContainer from "../crm/contacts/ContactsContainer";
import LeadsKanban from "../crm/leads/leadskanban";
import RolesPermissions from "../userManagement/rolesPermissions";
import CompaniesContainer from "../crm/companies/CompaniesContainer";

import PipelineDetails from "../crm/pipeline/pipelineDetails";
import PipelineContainer from "../crm/pipeline/PipelineContainer";
import CompaniesDetails from "../crm/companies/companiesDetails";
import Apexchart from "../uiInterface/charts/apexcharts";
import FeatherIcons from "../uiInterface/icons/feathericon";
import FontawesomeIcons from "../uiInterface/icons/fontawesome";
import MaterialIcons from "../uiInterface/icons/materialicon";
import PE7Icons from "../uiInterface/icons/pe7icons";
import SimplelineIcons from "../uiInterface/icons/simplelineicon";
import ThemifyIcons from "../uiInterface/icons/themify";
import TypiconIcons from "../uiInterface/icons/typicons";
import WeatherIcons from "../uiInterface/icons/weathericons";
import BasicInputs from "../uiInterface/forms/formelements/basic-inputs";
import CheckboxRadios from "../uiInterface/forms/formelements/checkbox-radios";
import InputGroup from "../uiInterface/forms/formelements/input-group";
import GridGutters from "../uiInterface/forms/formelements/grid-gutters";
import FormSelect from "../uiInterface/forms/formelements/form-select";
import FormMask from "../uiInterface/forms/formelements/form-mask";
import FileUpload from "../uiInterface/forms/formelements/fileupload";
import FormHorizontal from "../uiInterface/forms/formelements/layouts/form-horizontal";
import FormVertical from "../uiInterface/forms/formelements/layouts/form-vertical";
import FloatingLabel from "../uiInterface/forms/formelements/layouts/floating-label";
import FormValidation from "../uiInterface/forms/formelements/layouts/form-validation";
import FormSelect2 from "../uiInterface/forms/formelements/layouts/form-select2";
import FormWizard from "../uiInterface/forms/formelements/form-wizard";
import DataTables from "../uiInterface/table/data-tables";
import TablesBasic from "../uiInterface/table/tables-basic";
import IonicIcons from "../uiInterface/icons/ionicicons";
import BanIpAddress from "../settings/subscriptions/subscriptions";
import Alert from "../uiInterface/base-ui/alert";
import Permission from "../userManagement/permission";
import TablerIcons from "../uiInterface/icons/tablericons";
import BootstrapIcons from "../uiInterface/icons/bootstrapicons";
import RemixIcons from "../uiInterface/icons/remixIcons";
import FormPikers from "../uiInterface/forms/formpickers";
import Leaflet from "../uiInterface/map/leaflet";
import { Users } from "react-feather";
import SubscriptionsManagement from "../settings/subscriptions/subscriptions";
import TenantManagement from "../settings/tenantManagement/tenantManagement";
import UserManagement from "../settings/accessManagement/userManagement";
import TeamManagementNew from "../settings/accessManagement/teamManagement";
import NotFound from "../../components/NotFound";
import CRMRouteGuard from "../../components/CRMRouteGuard";
import ImportSettings from "../settings/importSettings/importSettings";
import ImportData from "../settings/importSettings/importData";
import RoleGuard from "../../components/RoleGuard";
import TasksPage from "../crm/tasks/TasksPage";
import SubscriptionList from "../crm/subscriptions/subscriptionList";
import Analytics from "../mainMenu/Analytics";
import ActivitiesReport from "../mainMenu/Analytics/ActivitiesReport";
import ChatAnalytics from "../mainMenu/Analytics/ChatAnalytics";
import CustomAnalytics from "../mainMenu/Analytics/CustomAnalytics";
import ProposalsContainer from "../crm/proposals/ProposalsContainer";
import ProposalDetails from "../crm/proposals/proposalDetails";
import ContractsContainer from "../crm/contracts/ContractsContainer";
import ContractDetails from "../crm/contracts/contractDetails";
import SocialConnection from "../auth/socialConnection";
import UserManagementSuperAdmin from "../settings/accessManagement/userManagementSuperAdmin";
import ApiDocumentation from "../documentation";
import NotificationSettings from "../settings/notificationSettings/NotificationSettings";
import StoragePage from "../settings/otherSettings/storage/Storage";
import CrmLevelConfiguration from "../settings/aiConfiguration/CrmLevelConfiguration";
import TenantLevelConfiguration from "../settings/aiConfiguration/TenantLevelConfiguration";
import AiUsageLogs from "../settings/aiConfiguration/AiUsageLogs";

const route = all_routes;

export const publicRoutes = [
  {
    path: route.dealsDashboard,
    element: <RoleBasedDashboard />,
    route: Route,
    title: "Deals Dashboard",
  },
  {
    path: route.newDashboard,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN"]}>
        <NewDashboard />
      </RoleGuard>
    ),
    route: Route,
    title: "Dashboard",
  },
  {
    path: route.revenueSummary,
    element: (
      <CRMRouteGuard>
        <RevenueSummary />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Revenue Summary",
  },
  {
    path: route.salesSummary,
    element: (
      <CRMRouteGuard>
        <SalesSummary />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Sales Dashboard",
  },
  {
    path: route.analytics,
    element: (
      <CRMRouteGuard>
        <Analytics />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Analytics",
  },
  {
    path: route.analyticsActivitiesReport,
    element: (
      <CRMRouteGuard>
        <ActivitiesReport />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Activities Report",
  },
  {
    path: route.analyticsChatAnalytics,
    element: (
      <CRMRouteGuard>
        <ChatAnalytics />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Chat Analytics",
  },
  {
    path: route.customAnalytics,
    element: (
      <CRMRouteGuard>
        <CustomAnalytics />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Custom Analytics",
  },
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/login" />,
    route: Route,
    title: "Login",
  },
  {
    path: route.chat,
    element: <Chat />,
    route: Route,
    title: "Chat",
  },
  {
    path: route.calendar,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <Calendar />
      </RoleGuard>
    ),
    route: Route,
    title: "Calendar",
  },
  {
    path: route.externalTasks,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <ExternalTask />
      </RoleGuard>
    ),
    route: Route,
    title: "External Tasks",
  },
  {
    path: route.leadsKanban,
    element: (
      <CRMRouteGuard>
        <LeadsKanban />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Leads Kanban",
  },

  {
    path: route.contactDetails,
    element: (
      <CRMRouteGuard>
        <ContactDetails />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Contact Details",
  },
  {
    path: route.tasks,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <TasksPage />
      </RoleGuard>
    ),
    route: Route,
    title: "Tasks",
  },

  {
    path: route.blankPage,
    element: <BlankPage />,
    route: Route,
    title: "Blank Page",
  },
  {
    path: route.redirectPage,
    element: <RedirectPage />,
    route: Route,
    title: "Redirect Page",
  },
  {
    path: route.manageusers,
    element: <Manageusers />,
    route: Route,
    title: "Manage Users",
  },
  {
    path: route.deals,
    element: (
      <CRMRouteGuard>
        <DealsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Deals",
  },
  {
    path: route.dealsList,
    element: (
      <CRMRouteGuard>
        <DealsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Deals List",
  },
  {
    path: route.dealsDetails,
    element: (
      <CRMRouteGuard>
        <DealsDetails />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Deals Details",
  },
  {
    path: route.dealsKanban,
    element: (
      <CRMRouteGuard>
        <DealsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Deals Kanban",
  },
  {
    path: route.proposals,
    element: (
      <CRMRouteGuard>
        <ProposalsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Proposals",
  },
  {
    path: route.proposalsList,
    element: (
      <CRMRouteGuard>
        <ProposalsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Proposals List",
  },
  {
    path: route.proposalsGrid,
    element: (
      <CRMRouteGuard>
        <ProposalsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Proposals Grid",
  },
  {
    path: route.proposalsDetails,
    element: (
      <CRMRouteGuard>
        <ProposalDetails />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Proposals Details",
  },
  {
    path: route.contracts,
    element: (
      <CRMRouteGuard>
        <ContractsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Contracts",
  },
  {
    path: route.contractsList,
    element: (
      <CRMRouteGuard>
        <ContractsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Contracts List",
  },
  {
    path: route.contractsGrid,
    element: (
      <CRMRouteGuard>
        <ContractsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Contracts Grid",
  },
  {
    path: route.contractsDetails,
    element: (
      <CRMRouteGuard>
        <ContractDetails />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Contracts Details",
  },
  {
    path: route.deleteRequest,
    element: <DeleteRequest />,
    route: Route,
    title: "Delete Request",
  },
  {
    path: route.companies,
    element: (
      <CRMRouteGuard>
        <CompaniesContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Companies",
  },
  {
    path: route.localization,
    element: <Localization />,
    route: Route,
    title: "Localization",
  },

  {
    path: route.leads,
    element: (
      <CRMRouteGuard>
        <LeadsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Leads",
  },
  {
    path: route.leadsList,
    element: (
      <CRMRouteGuard>
        <LeadsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Leads List",
  },
  {
    path: route.leadsGrid,
    element: (
      <CRMRouteGuard>
        <LeadsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Leads Grid",
  },
  {
    path: route.leadDetails,
    element: (
      <CRMRouteGuard>
        <LeadDetails />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Lead Details",
  },
  {
    path: route.dealssettings,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
          "SUPERADMIN",
          "PLATFORM_ANALYST",
        ]}
      >
        <DealsSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Deals",
  },
  {
    path: route.leadssettings,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
          "SUPERADMIN",
          "PLATFORM_ANALYST",
        ]}
      >
        <LeadsSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Leads",
  },
  {
    path: route.pipelinesettings,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
          "SUPERADMIN",
          "PLATFORM_ANALYST",
        ]}
      >
        <PipelineSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Pipeline",
  },
  {
    path: route.proposalssettings,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
          "SUPERADMIN",
          "PLATFORM_ANALYST",
        ]}
      >
        <ProposalsSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Proposals",
  },
  {
    path: route.contractssettings,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
          "SUPERADMIN",
          "PLATFORM_ANALYST",
        ]}
      >
        <ContractsSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Contracts",
  },
  {
    path: route.sourceSettings,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
        ]}
      >
        <SourceSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Source Configuration",
  },
  {
    path: route.salesActivityType,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
        ]}
      >
        <SalesActivityTypeSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Activity Types",
  },
  {
    path: route.lifecycleStatusReasonLost,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
        ]}
      >
        <LostReasons />
      </RoleGuard>
    ),
    route: Route,
    title: "Lost Reasons",
  },
  {
    path: route.lifecycleStatusReasonWon,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
        ]}
      >
        <WonReasons />
      </RoleGuard>
    ),
    route: Route,
    title: "Won Reasons",
  },
  {
    path: route.teamManagement,
    element: (
      <RoleGuard
        allowedRoles={["CLIENTADMIN", "SUPERADMIN", "PLATFORM_ANALYST"]}
      >
        <TeamManagementNew />
      </RoleGuard>
    ),
    route: Route,
    title: "Team Management",
  },
  {
    path: route.tenantManagement,
    element: (
      <RoleGuard allowedRoles={["SUPERADMIN", "PLATFORM_ANALYST", "APIADMIN"]}>
        <TenantManagement />
      </RoleGuard>
    ),
    route: Route,
    title: "Tenant Management",
  },
  {
    path: route.superadminSubscription,
    element: (
      <RoleGuard allowedRoles={["SUPERADMIN", "PLATFORM_ANALYST"]}>
        <SubscriptionList />
      </RoleGuard>
    ),
    route: Route,
    title: "Tenant Subscriptions",
  },
  {
    path: route.accessManagement,
    element: (
      <RoleGuard
        allowedRoles={["CLIENTADMIN", "SUPERADMIN", "PLATFORM_ANALYST"]}
      >
        <Navigate to={route.userManagement} replace />
      </RoleGuard>
    ),
    route: Route,
    title: "Access Management",
  },
  {
    path: route.userManagement,
    element: (
      <RoleGuard
        allowedRoles={["CLIENTADMIN", "SUPERADMIN", "PLATFORM_ANALYST"]}
      >
        <UserManagement />
      </RoleGuard>
    ),
    route: Route,
    title: "User Management",
  },
  {
    path: route.userManagementSuperAdmin,
    element: (
      <RoleGuard allowedRoles={["SUPERADMIN", "PLATFORM_ANALYST"]}>
        <UserManagementSuperAdmin />
      </RoleGuard>
    ),
    route: Route,
    title: "User Management",
  },
  {
    path: route.settings,
    element: <Navigate to={route.profile} replace />,
    route: Route,
    title: "Settings",
  },
  {
    path: route.generalSettings,
    element: <Navigate to={route.profile} replace />,
    route: Route,
    title: "General Settings",
  },
  {
    path: route.profile,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SUPERADMIN",
          "SALESUSER",
          "PLATFORM_ANALYST",
        ]}
      >
        <Profile />
      </RoleGuard>
    ),
    route: Route,
    title: "Profile",
  },
  {
    path: route.security,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SUPERADMIN",
          "SALESUSER",
          "PLATFORM_ANALYST",
        ]}
      >
        <Security />
      </RoleGuard>
    ),
    route: Route,
    title: "Security",
  },
  {
    path: route.notificationSettings,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <NotificationSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Notification Settings",
  },
  {
    path: route.notificationSettingsLeads,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <NotificationSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Notification Settings - Leads",
  },
  {
    path: route.notificationSettingsPipelines,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <NotificationSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Notification Settings - Pipelines",
  },
  {
    path: route.notificationSettingsDeals,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <NotificationSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Notification Settings - Deals",
  },
  {
    path: route.notificationSettingsProposals,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <NotificationSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Notification Settings - Proposals",
  },
  {
    path: route.notificationSettingsContracts,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <NotificationSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Notification Settings - Contracts",
  },
  {
    path: route.taskNotificationSettings,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <NotificationSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Task Notification Settings",
  },
  {
    path: route.expirationNotificationSettings,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <NotificationSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Expiration Notification Settings",
  },
  {
    path: route.subscriptionmanagement,
    element: (
      <RoleGuard
        allowedRoles={["CLIENTADMIN", "SUPERADMIN", "PLATFORM_ANALYST"]}
      >
        <SubscriptionsManagement />
      </RoleGuard>
    ),
    route: Route,
    title: "Subscription Management",
  },
  {
    path: route.storage,
    element: (
      <RoleGuard
        allowedRoles={["CLIENTADMIN"]}
      >
        <StoragePage />
      </RoleGuard>
    ),
    route: Route,
    title: "Storage",
  },
  {
    path: route.emailSettings,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <EmailSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Email Settings",
  },
  {
    path: route.chatSettings,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <EmailSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Chat Settings",
  },
  {
    path: route.calendarSettings,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <EmailSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Calendar Settings",
  },
  {
    path: route.apiIntegrationSettings,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN"]}>
        <ApiIntegrationSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "API Integration",
  },
  {
    path: route.adminApiIntegrationSettings,
    element: (
      <RoleGuard allowedRoles={["APIADMIN"]}>
        <AdminApiIntegration />
      </RoleGuard>
    ),
    route: Route,
    title: "API Integration",
  },
  {
    path: route.companySettings,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SUPERADMIN",
          "SALESUSER",
          "PLATFORM_ANALYST",
        ]}
      >
        <CompanySettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Company Settings",
  },
  {
    path: route.approvalPolicy,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SUPERADMIN",
          "SALESUSER",
          "PLATFORM_ANALYST",
        ]}
      >
        <ApprovalPolicy />
      </RoleGuard>
    ),
    route: Route,
    title: "Approval Policy",
  },
  {
    path: route.workflowConfiguration,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SUPERADMIN",
          "SALESUSER",
          "PLATFORM_ANALYST",
        ]}
      >
        <EmailWorkflow />
      </RoleGuard>
    ),
    route: Route,
    title: "Workflow Configuration",
  },
  {
    path: route.autoCreationRules,
    element: (
      <RoleGuard
        allowedRoles={[
          "CLIENTADMIN",
          "SALESUSER",
        ]}
      >
        <EmailSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Auto-Creation Rule",
  },
  {
    path: route.productServices,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <ProductServices />
      </RoleGuard>
    ),
    route: Route,
    title: "Products & Services",
  },
  {
    path: route.customFields,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <CustomFields />
      </RoleGuard>
    ),
    route: Route,
    title: "Custom Fields",
  },
  {
    path: route.auditLog,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN"]}>
        <AuditLog />
      </RoleGuard>
    ),
    route: Route,
    title: "Audit Log",
  },

  {
    path: route.language,
    element: <Language />,
    route: Route,
    title: "Language",
  },
  {
    path: route.importSettings,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <ImportSettings />
      </RoleGuard>
    ),
    route: Route,
    title: "Import Settings",
  },
  {
    path: route.importData,
    element: (
      <RoleGuard allowedRoles={["CLIENTADMIN", "SALESUSER"]}>
        <ImportData />
      </RoleGuard>
    ),
    route: Route,
    title: "Import Data",
  },
  {
    path: route.email,
    element: <EmailList type="inbox" />,
    route: Route,
    title: "Email",
  },

  {
    path: route.contactList,
    element: (
      <CRMRouteGuard>
        <ContactsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Contact List",
  },
  {
    path: route.deleteRequest,
    element: <DeleteRequest />,
    route: Route,
    title: "Delete Request",
  },
  {
    path: route.rolesPermissions,
    element: <RolesPermissions />,
    route: Route,
    title: "Roles Permissions",
  },
  {
    path: route.contactGrid,
    element: (
      <CRMRouteGuard>
        <ContactsContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Contact Grid",
  },
  {
    path: route.companiesGrid,
    element: (
      <CRMRouteGuard>
        <CompaniesContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Companies Grid",
  },
  {
    path: route.pipelines,
    element: (
      <CRMRouteGuard>
        <PipelineContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Pipeline",
  },
  {
    path: route.pipelinesList,
    element: (
      <CRMRouteGuard>
        <PipelineContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Pipelines List",
  },
  {
    path: route.pipelinesGrid,
    element: (
      <CRMRouteGuard>
        <PipelineContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Pipelines Grid",
  },
  {
    path: route.pipelinesKanban,
    element: (
      <CRMRouteGuard>
        <PipelineContainer />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Pipelines Kanban",
  },
  {
    path: route.pipelineDetails,
    element: (
      <CRMRouteGuard>
        <PipelineDetails />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Pipeline Details",
  },
  {
    path: route.companyDetails,
    element: (
      <CRMRouteGuard>
        <CompaniesDetails />
      </CRMRouteGuard>
    ),
    route: Route,
    title: "Company Details",
  },
  {
    path: route.apexChat,
    element: <Apexchart />,
    route: Route,
    title: "Apexchart",
  },
  {
    path: route.featherIcons,
    element: <FeatherIcons />,
    route: Route,
    title: "Feather Icons",
  },
  {
    path: route.fantawesome,
    element: <FontawesomeIcons />,
    route: Route,
    title: "Fontawesome Icons",
  },
  {
    path: route.materialIcon,
    element: <MaterialIcons />,
    route: Route,
    title: "Material Icons",
  },
  {
    path: route.pe7icon,
    element: <PE7Icons />,
    route: Route,
    title: "PE7 Icons",
  },
  {
    path: route.simpleLineIcon,
    element: <SimplelineIcons />,
    route: Route,
    title: "SimplelineIcons",
  },
  {
    path: route.themifyIcon,
    element: <ThemifyIcons />,
    route: Route,
    title: "Themify Icons",
  },
  {
    path: route.typicon,
    element: <TypiconIcons />,
    route: Route,
    title: "Typicon Icons",
  },
  {
    path: route.basicInput,
    element: <BasicInputs />,
    route: Route,
    title: "Basic Inputs",
  },
  {
    path: route.weatherIcon,
    element: <WeatherIcons />,
    route: Route,
    title: "Weather Icons",
  },
  {
    path: route.checkboxandRadion,
    element: <CheckboxRadios />,
    route: Route,
    title: "Checkbox Radios",
  },
  {
    path: route.inputGroup,
    element: <InputGroup />,
    route: Route,
    title: "Input Group",
  },
  {
    path: route.gridandGutters,
    element: <GridGutters />,
    route: Route,
    title: "Grid Gutters",
  },
  {
    path: route.formSelect,
    element: <FormSelect />,
    route: Route,
    title: "Form Select",
  },
  {
    path: route.formMask,
    element: <FormMask />,
    route: Route,
    title: "Form Mask",
  },
  {
    path: route.fileUpload,
    element: <FileUpload />,
    route: Route,
    title: "File Upload",
  },
  {
    path: route.horizontalForm,
    element: <FormHorizontal />,
    route: Route,
    title: "Form Horizontal",
  },
  {
    path: route.verticalForm,
    element: <FormVertical />,
    route: Route,
    title: "Form Vertical",
  },
  {
    path: route.floatingLable,
    element: <FloatingLabel />,
    route: Route,
    title: "Floating Label",
  },
  {
    path: route.formValidation,
    element: <FormValidation />,
    route: Route,
    title: "Form Validation",
  },
  {
    path: route.reactSelect,
    element: <FormSelect2 />,
    route: Route,
    title: "FormSelect2",
  },
  {
    path: route.formWizard,
    element: <FormWizard />,
    route: Route,
    title: "FormWizard",
  },
  {
    path: route.dataTable,
    element: <DataTables />,
    route: Route,
    title: "DataTables",
  },
  {
    path: route.tableBasic,
    element: <TablesBasic />,
    route: Route,
    title: "Tables Basic",
  },
  {
    path: route.iconicIcon,
    element: <IonicIcons />,
    route: Route,
    title: "Ionic Icons",
  },
  {
    path: route.sweetalert,
    element: <Alert />,
    route: Route,
    title: "Alert",
  },
  {
    path: route.permissions,
    element: <Permission />,
    route: Route,
    title: "Permission",
  },
  {
    path: route.tablericons,
    element: <TablerIcons />,
    route: Route,
    title: "Icon Tabler",
  },
  {
    path: route.bootstrapicons,
    element: <BootstrapIcons />,
    route: Route,
    title: "Icon Bootstap",
  },
  {
    path: route.remixicons,
    element: <RemixIcons />,
    route: Route,
    title: "Icon Remix",
  },
  {
    path: route.formpicker,
    element: <FormPikers />,
    route: Route,
    title: "Form Pickers",
  },
  {
    path: route.mapleaflet,
    element: <Leaflet />,
    route: Route,
    title: "Leaflet Map",
  },

  {
    path: route.email,
    element: <EmailList type="inbox" />,
    route: Route,
    title: "Email",
  },

  {
    path: route.emailImportant,
    element: (
      <EmailProviderGuard>
        <EmailList type="important" />
      </EmailProviderGuard>
    ),
    route: Route,
    title: "Important Emails",
  },
  {
    path: route.emailSent,
    element: (
      <EmailProviderGuard>
        <EmailList type="sent" />
      </EmailProviderGuard>
    ),
    route: Route,
    title: "Sent Emails",
  },
  {
    path: route.emailDraft,
    element: (
      <EmailProviderGuard>
        <EmailList type="draft" />
      </EmailProviderGuard>
    ),
    route: Route,
    title: "Draft Emails",
  },
  {
    path: route.emailSpam,
    element: (
      <EmailProviderGuard>
        <EmailList type="spam" />
      </EmailProviderGuard>
    ),
    route: Route,
    title: "Spam Emails",
  },
  {
    path: route.emailTrash,
    element: (
      <EmailProviderGuard>
        <EmailList type="trash" />
      </EmailProviderGuard>
    ),
    route: Route,
    title: "Trash Emails",
  },
  {
    path: route.emailFolder,
    element: (
      <EmailProviderGuard>
        <EmailList type="folder" />
      </EmailProviderGuard>
    ),
    route: Route,
    title: "Email Folder",
  },
  {
    path: route.emailDetail,
    element: (
      <EmailProviderGuard>
        <EmailDetail />
      </EmailProviderGuard>
    ),
    route: Route,
    title: "Email Detail",
  },

  {
    path: route.aiConfiguration,
    element: (
      <RoleGuard allowedRoles={["SUPERADMIN"]}>
        <Navigate to={route.aiConfigurationCrmLevel} replace />
      </RoleGuard>
    ),
    route: Route,
    title: "AI Configuration",
  },
  {
    path: route.aiConfigurationCrmLevel,
    element: (
      <RoleGuard allowedRoles={["SUPERADMIN"]}>
        <CrmLevelConfiguration />
      </RoleGuard>
    ),
    route: Route,
    title: "CRM Level Configuration",
  },
  {
    path: route.aiConfigurationTenantLevel,
    element: (
      <RoleGuard allowedRoles={["SUPERADMIN"]}>
        <TenantLevelConfiguration />
      </RoleGuard>
    ),
    route: Route,
    title: "Tenant Level Configuration",
  },
  {
    path: route.aiConfigurationUsageLogs,
    element: (
      <RoleGuard allowedRoles={["SUPERADMIN"]}>
        <AiUsageLogs />
      </RoleGuard>
    ),
    route: Route,
    title: "AI Usage Logs",
  },

  {
    path: "*",
    element: <NotFound />,
    route: Route,
    title: "Not Found",
  },
];

export const authRoutes = [
  {
    path: route.apiDocumentation,
    element: <ApiDocumentation />,
    route: Route,
    title: "API Documentation",
  },
  {
    path: route.comingSoon,
    element: <ComingSoon />,
    route: Route,
    title: "ComingSoon",
  },
  {
    path: route.login,
    element: <Login />,
    route: Route,
    title: "Login",
  },
  {
    path: route.register,
    element: <Register />,
    route: Route,
    title: "Register",
  },
  {
    path: route.accountVerification,
    element: <AccountVerification />,
    route: Route,
    title: "AccountVerification",
  },
  {
    path: route.emailVerification,
    element: <EmailVerification />,
    route: Route,
    title: "EmailVerification",
  },
  {
    path: route.emailConnection,
    element: <EmailConnection />,
    route: Route,
    title: "EmailConnection",
  },
  {
    path: route.socialConnection,
    element: <SocialConnection />,
    route: Route,
    title: "SocialConnection",
  },
  {
    path: route.success,
    element: <Success />,
    route: Route,
    title: "Success",
  },

  {
    path: route.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
    title: "Forgot Password",
  },
  {
    path: route.error404,
    element: <Error404 />,
    route: Route,
    title: "Error404",
  },
  {
    path: route.error500,
    element: <Error500 />,
    route: Route,
    title: "Error500",
  },
  {
    path: route.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
    title: "Under Maintenance",
  },
  {
    path: route.tenantManagement,
    element: (
      <RoleGuard allowedRoles={["SUPERADMIN", "PLATFORM_ANALYST", "APIADMIN"]}>
        <TenantManagement />
      </RoleGuard>
    ),
    route: Route,
    title: "Tenant Management",
  },
];
